import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Contact() {
  return <footer id="contact" className="bg-navy text-white py-24 lg:py-32 relative overflow-hidden" data-id="element-107">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 gold-gradient-bg" data-id="element-108" />
      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[#D4AF37]/5 blur-3xl pointer-events-none" data-id="element-109" />
      <div className="absolute top-20 -left-20 w-64 h-64 rounded-full bg-[#2567A4]/10 blur-3xl pointer-events-none" data-id="element-110" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-16 lg:gap-12" data-id="element-112">
          <div className="lg:col-span-5" data-id="element-113">
            <div className="bg-cream p-4 inline-block mb-10 rounded-sm shadow-[0_0_20px_rgba(212,175,55,0.1)]" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/gRNdUYNsrwYKSGkPVbsmda/Logo_wanja_advocates.jpg" alt="Wanja Konji & Co. Advocates Logo" className="h-16 object-contain mix-blend-multiply" data-id="element-115" />
            </div>
            <p className="font-cormorant text-2xl text-blue-100/80 font-light max-w-md leading-relaxed mb-8 italic" data-id="element-116">
              A trusted legal partner delivering cutting-edge solutions and
              advancing justice in Kenya and beyond.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7" data-id="element-117">
            <h4 className="text-xs font-bold tracking-[0.3em] text-[#D4AF37] uppercase mb-8 pb-4 border-b border-white/10 inline-block" data-id="element-118">
              Contact Us
            </h4>
            <ul className="space-y-8" data-id="element-119">
              <li className="flex items-start group" data-id="element-120">
                <PhoneIcon className="h-5 w-5 text-[#D4AF37] mr-5 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-121" />
                <a href="tel:+254703327403" className="text-blue-50/80 hover:text-white hover:translate-x-1 transition-all duration-300 font-light tracking-wide" data-id="element-122">
                  +254 703 327 403
                </a>
              </li>
              <li className="flex items-start group" data-id="element-123">
                <MailIcon className="h-5 w-5 text-[#D4AF37] mr-5 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-124" />
                <a href="mailto:sheila@wanjakonjiadvocates.com" className="text-blue-50/80 hover:text-white hover:translate-x-1 transition-all duration-300 font-light tracking-wide break-all" data-id="element-125">
                  sheila@wanjakonjiadvocates.com
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3" data-id="element-126">
            <h4 className="text-xs font-bold tracking-[0.3em] text-[#D4AF37] uppercase mb-8 pb-4 border-b border-white/10 inline-block" data-id="element-127">
              Location
            </h4>
            <div className="flex items-start group" data-id="element-128">
              <MapPinIcon className="h-5 w-5 text-[#D4AF37] mr-5 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" strokeWidth={1.5} data-id="element-129" />
              <address className="text-blue-50/80 not-italic font-light leading-relaxed tracking-wide" data-id="element-130">
                Applewood Adams,
                <br data-id="element-131" />
                4th Floor, Suite 403,
                <br data-id="element-132" />
                Ngong Road,
                <br data-id="element-133" />
                Nairobi, Kenya
              </address>
            </div>
          </div>
        </div>

        <div className="mt-32 pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-blue-100/50 font-light tracking-wider" data-id="element-134">
          <p data-id="element-135">
            &copy; {new Date().getFullYear()} Wanja Konji & Co. Advocates. All
            rights reserved.
          </p>
          <p className="mt-4 md:mt-0 font-cormorant italic text-lg" data-id="element-136">
            Established March 2025
          </p>
        </div>
      </div>
    </footer>;
}